// App target untuk forward laporan meeting ke AdminHebat.
// 1=Finance (Kledo), 2=HR (Gajihub), 3=WA (CRM).
export const MEETING_APP = {
  FINANCE: 1,
  HR: 2,
  WA: 3,
};

export const MEETING_APP_OPTIONS = [
  { value: MEETING_APP.FINANCE, label: "Kledo" },
  { value: MEETING_APP.HR, label: "Gajihub" },
  { value: MEETING_APP.WA, label: "CRM" },
];

// Mirror dari backend WAMeetingAdminGroupAppEnum: group_id → app_id.
export const MEETING_ADMIN_GROUP_APP_MAP = {
  4: MEETING_APP.FINANCE,
  7: MEETING_APP.FINANCE,
  8: MEETING_APP.FINANCE,
  9: MEETING_APP.HR,
  10: MEETING_APP.HR,
};

// Resolve app_id default dari admin_group_id. Fallback Finance bila tak ada di map.
export const resolveAdminGroupAppId = (groupId) =>
  MEETING_ADMIN_GROUP_APP_MAP[Number(groupId)] ?? MEETING_APP.FINANCE;

// Brand (nama + logo) pengirim WhatsApp per app_id — untuk header pratinjau.
export const MEETING_APP_BRAND = {
  [MEETING_APP.FINANCE]: {
    name: "Kledo",
    logo: "https://kledo-live-user.s3.ap-southeast-1.amazonaws.com/WAIMG/107471/phone-number/1.png?lastmod=1784621758280",
  },
  [MEETING_APP.HR]: {
    name: "Gajihub",
    logo: "https://kledo-live-user.s3.ap-southeast-1.amazonaws.com/WAIMG/107471/phone-number/2.png?lastmod=1784621737419",
  },
  [MEETING_APP.WA]: {
    name: "CRM",
    logo: "https://kledo-live-user.s3.ap-southeast-1.amazonaws.com/WAIMG/107471/phone-number/5.png?lastmod=1784621765970",
  },
};

// Fallback Kledo bila app_id tak dikenal.
export const resolveMeetingAppBrand = (appId) =>
  MEETING_APP_BRAND[Number(appId)] || MEETING_APP_BRAND[MEETING_APP.FINANCE];
